export const TextFieldTypes = [
	{
		value: 'ShortText',
		description: 'Short Text'
	},
	{
		value: 'LongText',
		description: 'Long Text'
	}
]